// extracted by mini-css-extract-plugin
export var center = "_49-2";
export var clickableRow = "_49-5";
export var expandedRow = "_49-7";
export var hoverable = "_49-4";
export var left = "_49-1";
export var right = "_49-3";
export var row = "_49-0";
export var selectedRow = "_49-6";
export var summaryRow = "_49-8";